var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('CNotificationsFromStore'),_c('TopBar',{attrs:{"user-data":_vm.userData}}),_c('v-main',{staticStyle:{"background-color":"#F5F6F8"}},[_c('div',{staticClass:"pa-8"},[_c('keep-alive',{attrs:{"include":"lkLayout,adminLayout"}},[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }